import { Injectable, NgZone } from '@angular/core';
import { CustomerService } from '../../modules/customer/customer.service';
import { CommonService } from '../../shared/services/common.service';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ENDPOINTS } from '../../core/services/api.service';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CustomerSharedService {
  customer: any = null;
  apiCallLoaders = { isCustomerLoading: false };
  checklistConfig: any = null;
  constructor(
    public customerService: CustomerService,
    public commonSvc: CommonService,
    public ngZone: NgZone
  ) { }

  getCustomerById(params: any): Observable<any> {

    this.apiCallLoaders.isCustomerLoading = true;
    return new Observable(observer => {
      this.ngZone.runOutsideAngular(() => {
        this.customerService.getCustomerById(params).subscribe(
          (response: any) => {
            if (response?.status === 200 && response?.data) {
              this.ngZone.run(() => {
                this.apiCallLoaders.isCustomerLoading = false;
                observer.next(response.data);
              });
            } else {
              this.ngZone.run(() => {
                this.apiCallLoaders.isCustomerLoading = false;
                this.commonSvc.message.info('No customer data found for the provided ID.', { nzDuration: 5000 });
                observer.error('No customer data found');
              });
            }
          }
        );
      });
    });
  }

  getLocationByCustomerId(customer_id: string): Observable<any> {
    const headers = new HttpHeaders({ 'x-customer-id': customer_id });
    return this.commonSvc.httpSvc
      .get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.LOCATION.GET_LOCATION, headers)
      .pipe(
        map((response: any) => {
          if (response.status === 200 && response?.data) {
            return response.data; // Return the entire result array
          } else {
            throw new Error('Invalid response format');
          }
        }),
      );
  }

  setChecklistConfig(config: any): void {
    this.checklistConfig = config;
  }

  getChecklistConfig(): any {
    return this.checklistConfig;
  }
}